var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7633 4.23268C10.7966 3.26602 9.46992 2.66602 7.99659 2.66602C5.04992 2.66602 2.66992 5.05268 2.66992 7.99935C2.66992 10.946 5.04992 13.3327 7.99659 13.3327C10.4833 13.3327 12.5566 11.6327 13.1499 9.33268H11.7633C11.2166 10.886 9.73659 11.9993 7.99659 11.9993C5.78992 11.9993 3.99659 10.206 3.99659 7.99935C3.99659 5.79268 5.78992 3.99935 7.99659 3.99935C9.10326 3.99935 10.0899 4.45935 10.8099 5.18602L8.66326 7.33268H13.3299V2.66602L11.7633 4.23268Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.f1d0c5dc75d3f8b47313865e7ac03bf9.svg";
export { ForwardRef as ReactComponent };